import { removeParamUrl } from '@/helpers';
import * as tokenService from '@/services/token';
import { ACCOUNTS_AMBIENT, ACCOUNTS_TOKEN, NUTROR_LOGO } from '@/settings';

export interface IParams {
  logo: string;
  bg: string;
  create: string;
  register: string;
  env: string;
  email?: string;
  dark?: string;
  btnColor?: string;
}

export const loginAccounts = (callback?: (isAuthenticated: boolean) => void, courseHash?: string) => {
  (window as any).Eduzz?.Accounts?.login(
    ACCOUNTS_TOKEN,
    sendParams({ create: courseHash ? 'true' : 'false' })
  ).subscribe(async (token: any) => {
    if (token) {
      const user = await tokenService.makeLogin(token, courseHash);
      callback && callback(!!user);
    }

    const url = removeParamUrl(`${window.location.pathname}${window.location.search}`, ['accounts_token']);
    window.history.pushState(null, '', url);
  });
};

const sendParams = (dataMerge?: { create: 'true' | 'false' }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email') || '';

  const params: IParams = {
    logo: NUTROR_LOGO,
    bg: 'https://cdn.nutror.com/assets/img/background_default_xp.jpeg',
    create: 'false',
    register: 'false',
    env: ACCOUNTS_AMBIENT,
    email,
    dark: 'true',
    btnColor: '#ffbc00',
    ...dataMerge
  };

  return params;
};

export default { loginAccounts };
